<template>
  <div class="pay-success">
    <header>
      <img src="../../assets/images/pay-img/pay-success-img/icon-24-fanhui.png" alt="" @click="$router.replace('/my')"> 
      <p>
        支付成功
      </p>
    </header>
    <section>
      <div class="img">
        <img src="../../assets/images/pay-img/pay-success-img/success.png" alt="">
      </div>
      <p>
        您已支付成功！
      </p>
      <div class="order">
        查看订单
      </div>
      <div class="home">
        返回首页
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data(){
    return{
      
    }
  },
  methods:{
    
  }
}
</script>
<style lang="less" scoped>
  .pay-success{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    header{
      width: 100%;
      height: .88rem;
      display: flex;
      align-items: center;
      border-bottom: .01rem #BFBFBF solid;
      img{
        width: .18rem;
        height: .35rem;
        margin-left: .33rem;
      }
      p{
        width: 6.54rem;
        font-family: PingFang-SC-Bold;
        color: #333333;
        font-size: 0.36rem;
        font-weight: bold;
        text-align: center;
      }
    }
    section{
      flex: 1;
      overflow: hidden;
      // 图片
      .img{
        width: 1.94rem;
        height: 2.72rem;
        margin: 0 auto;
        margin-top: .95rem;
        img{
          width: 1.94rem;
          height: 2.72rem;
        }
      }
      p{
        margin-top: .61rem;
        font-size: 0.36rem;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(51,51,51,1);
        text-align: center;
      }
      .order{
        width: 4.8rem;
        height: .88rem;
        margin: 0 auto;
        background: #EF8201;
        border-radius: .2rem;
        text-align: center;
        line-height: .88rem;
        font-size:0.36rem;
        font-family:PingFang SC;
        font-weight:bold;
        color:rgba(255,255,255,1);
        margin-top: .2rem;
        margin-bottom: .2rem;
      }
      .home{
        width: 4.8rem;
        height: .88rem;
        margin: 0 auto;
        border: .01rem #EF8201 solid;
        text-align: center;
        line-height: .88rem;
        font-size:0.36rem;
        font-family:PingFang SC;
        font-weight:bold;
        color:rgba(239,130,1,1);
        border-radius: .2rem;
      }
    }
  }
</style>